import React, { Component } from "react";
import { Dialog, DialogTitle, Button, DialogActions, DialogContent, TextField, Typography, FormControl, MenuItem, InputLabel, Select, Checkbox, FormLabel } from "@material-ui/core";
import "./BuildingDialog.css";
import { Formatter, isNullOrEmpty } from "./Util";

export class BuildingDialog extends Component {
	constructor(props) {
		super(props);
		this.getData();
		this.state = {
			BuildingData: {},
			open: false,
		};

		this.onClose = this.onClose.bind(this);
		this.saveData = this.saveData.bind(this);
		this.toggleCheckbox = this.toggleCheckbox.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.BuildingsID !== prevProps.BuildingsID || (this.props.visible !== prevProps.visible && this.props.visible)) {
			this.getData();
		}
	}
	async getData() {
		var res = {};
		if (this.props.BuildingsID) {
			const data = await fetch("Building/GetBuildingData", {
				method: "Post",
				headers: {
					"Content-Type": "application/json",
				},
				cache: "no-cache",
				body: JSON.stringify({ buildingsId: this.props.BuildingsID }),
			});
			res = await data.json();
		}
		this.setState({ BuildingData: res, open: true });
	}

	async saveData() {
		var toSave = this.state.BuildingData;

		if (isNullOrEmpty(toSave.building_name)) {
			alert("A building name is required.");
			return;
		}

		toSave.buildings_id = this.props.BuildingsID;
		await fetch("Building/SaveBuildingData", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify(toSave),
		});

		this.onClose();
	}

	dynamicOnChange = (event) => {
		var columnName = null;
		if (event.target.nodeName === "INPUT") {
			columnName = event.target.attributes.columnname.value;
		} else if (event.currentTarget.nodeName === "LI") {
			columnName = event.currentTarget.dataset.columnname;
		}

		var bldg = this.state.BuildingData;
		bldg[columnName] = event.target.value;
		if (event.target.type === "checkbox") {
			bldg[columnName] = event.target.checked;
		}

		this.setState({ BuildingData: bldg });
	};

	toggleCheckbox = (event) => {
		var dt = this.state.BuildingData;
		dt.is_active = event.target.checked;
		this.setState({ BuildingData: dt });
	};

	onClose() {
		this.setState({ open: false });
		this.props.OnClose && this.props.OnClose();
	}

	render() {
		var baseData = this.state.BuildingData;
		var inputProps = { readOnly: false };
		var labelProps = { shrink: true };
		return (
			<Dialog open={this.props.visible} onClose={this.onClose} fullWidth={true} maxWidth="md">
				<DialogTitle>{this.props.BuildingsID ? baseData.building_name : "New Building"}</DialogTitle>
				<DialogContent>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnName: "building_name" }} label="Name" className="ticket-control" value={baseData.building_name} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnName: "address1" }} label="Address 1" className="ticket-control" value={baseData.address1} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnName: "address2" }} label="Address 2" className="ticket-control" value={baseData.address2} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnName: "city" }} label="City" className="ticket-control" value={baseData.city} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnName: "state" }} label="State" className="ticket-control" value={baseData.state} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnName: "zip" }} label="Zip" className="ticket-control" value={baseData.zip} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<div className="ticket-control" style={{ display: "inline-block" }}>
						<FormLabel style={{ display: "block", marginBottom: "0px" }}>Is Active?</FormLabel>
						<Checkbox onChange={this.toggleCheckbox} checked={baseData.is_active || false} />
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.saveData} color="primary">
						Save
					</Button>
					<Button onClick={this.onClose} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
